/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type instantSearch_viewer$ref: FragmentReference;
export type instantSearch_viewer = {|
  +trackInstantSearch: ?{|
    +artists: ?$ReadOnlyArray<?{|
      +id: string,
      +name: ?string,
      +slug: ?string,
    |}>,
    +tracks: ?$ReadOnlyArray<?{|
      +id: string,
      +slug: ?string,
      +title: ?string,
      +artist: ?{|
        +name: ?string,
      |},
    |}>,
    +taxonomies: ?$ReadOnlyArray<?{|
      +id: string,
      +internal_id: ?number,
      +name: ?string,
      +terms: ?$ReadOnlyArray<?{|
        +id: string,
        +name: ?string,
      |}>,
    |}>,
  |},
  +$refType: instantSearch_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "instantSearch_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "query",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "trackInstantSearch",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query",
          "type": "String"
        }
      ],
      "concreteType": "InstantSearchResult",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "artists",
          "storageKey": null,
          "args": null,
          "concreteType": "Artist",
          "plural": true,
          "selections": [
            v0,
            v1,
            v2
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tracks",
          "storageKey": null,
          "args": null,
          "concreteType": "Track",
          "plural": true,
          "selections": [
            v0,
            v2,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "artist",
              "storageKey": null,
              "args": null,
              "concreteType": "Artist",
              "plural": false,
              "selections": [
                v1
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "taxonomies",
          "storageKey": null,
          "args": null,
          "concreteType": "Taxonomy",
          "plural": true,
          "selections": [
            v0,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "internal_id",
              "args": null,
              "storageKey": null
            },
            v1,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "terms",
              "storageKey": null,
              "args": null,
              "concreteType": "TaxonomyTerm",
              "plural": true,
              "selections": [
                v0,
                v1
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node/*: any*/).hash = 'bf1040f94f14d841b1c77a1a077bc8b1';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/instantSearch_viewer.graphql.js